import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccessPieton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.8949,
			cy: 9.8949,
			r: 9.8949,
			fill: "#2E4F6F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.3062,
			cy: 2.66973,
			r: 1.26617,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.17795 7.45314L8.64412 7.02937V9.95335C8.64412 10.4396 7.86533 12.1009 7.23494 13.4456L7.20334 13.513C6.0507 15.1741 5.25402 16.3805 4.99976 16.776L7.54231 17.793C7.62708 17.793 7.74575 17.6913 7.54231 17.2845C7.33888 16.8777 7.0903 16.776 6.99143 16.776C7.06207 16.6912 7.27113 16.4115 7.54231 15.9708C7.88129 15.4199 8.94077 14.0215 9.36454 13.0468C9.70355 12.2671 9.92956 11.4224 10.0002 11.0975L12.0766 17.793H14.7887L14.5769 17.2845L13.5598 16.776L11.0172 8.89394V7.7074C11.7659 8.41367 13.3233 9.27698 14.2378 9.69909C14.7887 9.95335 14.704 9.10582 14.5769 8.89394C14.4751 8.72443 14.0825 8.4843 13.8988 8.38542L11.8648 6.77511C11.6105 6.16772 11.0342 4.85969 10.763 4.48678C10.424 4.02064 9.95781 4.19015 9.70355 4.19015C9.50014 4.19015 9.11028 4.3879 8.94077 4.48678L7.20334 7.02937C6.92082 8.00403 6.34732 10.0212 6.31342 10.2924C6.27104 10.6314 6.39816 10.8009 6.99143 10.7585C7.46605 10.7246 7.55644 10.2076 7.54231 9.95335L8.17795 7.45314Z",
			fill: "white"
		})
	]
});
export default SvgAccessPieton;
